import { ItfEmailTip } from './type';

export const initTip: ItfEmailTip = {
    type: 'fail',
    text: '',
};

export const getSubscribe = (email: string) => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    return {
        source: 'WEB_NEW_PRODUCT_SUB',
        contactListId: '744837605',
        email,
        fields: [
            {
                type: 'single',
                id: '4423',
                value: 1,
                overwrite: true,
            },
            {
                type: 'single',
                id: '31',
                value: 1,
                overwrite: false,
            },
            {
                type: 'multiple',
                id: '14003',
                value: [1],
                overwrite: false,
            },
            {
                type: 'multiple',
                id: '9435',
                value: [43],
                overwrite: false,
            },
            {
                type: 'multiple',
                id: '14005',
                value: [1],
                overwrite: false,
            },
            {
                type: 'text',
                id: '14004',
                value: dateString,
                overwrite: false,
            },
        ],
    };
};
